// extracted by mini-css-extract-plugin
export default {"root":"cHbZy_rAHf","mono":"_2SNe_x81Ib","link":"LUI6m76ply"};